"use strict";

exports.__esModule = true;
exports.LabelDividerWrapper = exports.Badge = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Badge = _interopRequireDefault(require("../../badges/badge/Badge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LabelDividerWrapper = _styledComponents.default.div`
    position: relative;
    text-align: center;    
    margin: ${({
  theme
}) => theme.space[6]} 0;

    &:after {
        content: "";
        height: 2px;
        position: absolute;
        width: 100%;
        top: 12px;
        left: 0;
        z-index: 0;
        background-color: ${({
  theme
}) => theme.colors.labelDivider.border};
    }
`;
exports.LabelDividerWrapper = LabelDividerWrapper;
const StyledBadge = (0, _styledComponents.default)(_Badge.default)`
    position: relative;
    z-index: 1;
    font-weight: ${({
  theme
}) => theme.fontWeights.light};
    color: ${({
  theme
}) => theme.colors.labelDivider.badge.text};
    background-color: ${({
  theme
}) => theme.colors.labelDivider.badge.background};
    border-color: ${({
  theme
}) => theme.colors.labelDivider.badge.border};
`;
exports.Badge = StyledBadge;